import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {ReactiveFormsModule} from '@angular/forms';
import {TranslocoModule} from '@jsverse/transloco';

import {MatTableModule} from '@angular/material/table';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatSortModule} from '@angular/material/sort';
import {MatButtonModule} from '@angular/material/button';
import {MatInputModule} from '@angular/material/input';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatDialogModule} from '@angular/material/dialog';
import {MatIconModule} from '@angular/material/icon';
import {MatDividerModule} from '@angular/material/divider';

import {SharedModule} from '../../shared/shared.module';
import {CoreModule} from '../../core/core.module';

import {PatientComponent} from './patient.component';
import {PatientsListComponent} from './patients-list/patients-list.component';
import {PatientRestApiService} from './services/http/patient-rest-api.service';
import {PatientDetailsComponent} from './patient-details/patient-details.component';
import {PatientResolver} from './services/resolver/patient.resolver';
import {PatientFeatureListComponent} from './components/patient-feature-list/patient-feature-list.component';
import {FileParserService} from './services/file-parser/file-parser.service';
import {MeanPressureGraphComponent} from './components/mean-pressure-graph/mean-pressure-graph.component';
import {CommentComponent} from './components/comment/comment.component';
import {PatientDataParserService} from './services/data/patient-data-parser.service';
import {MeanPressureComputationService} from './services/file-parser/mean-pressure-computation.service';
import {RawPressureGraphComponent} from './components/raw-pressure-graph/raw-pressure-graph.component';


@NgModule({
  declarations: [
    PatientComponent,
    PatientsListComponent,
    PatientDetailsComponent,
    PatientFeatureListComponent,
    MeanPressureGraphComponent,
    CommentComponent,
    RawPressureGraphComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    TranslocoModule,

    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatButtonModule,
    MatInputModule,
    MatProgressBarModule,
    MatDatepickerModule,
    MatDialogModule,
    MatIconModule,
    MatDividerModule,

    SharedModule,
    CoreModule,
  ],
  providers: [
    PatientRestApiService,
    PatientResolver,
    FileParserService,
    PatientDataParserService,
    MeanPressureComputationService,
  ],
})
export class PatientModule {
}
